import React, { useRef, useCallback, useEffect } from 'react';
import config from 'config/config';
import {
  getPostIdFromConversationId,
  getSpotIdFromConversationId
} from '../../../../../utils/miscellaneous';

const VIEW_CONVERSATION_ID = 'spcv_view-conversation-options';

// TODO: Support comments modal here as well.
// TODO: This is a temporary modal until native launcher script support will be available.
export const BackToCommentsModal = ({
  message,
  contentType = 'COMMENTS',
  spotId,
  inpageSkin = 'light'
}) => {
  const iframeRef = useRef<HTMLIFrameElement>();
  const isDarkTheme = inpageSkin === 'dark';

  const appendLauncherScript = useCallback(() => {
    let { conversationId, conversationMessageId, parentId } = message;
    const isPostsContentType = contentType === 'POSTS';

    try {
      conversationId = decodeURIComponent(conversationId);
    } catch (err) {
      // reportError
      console.error(err);
    }
    const spotId = getSpotIdFromConversationId(conversationId);
    const postId = getPostIdFromConversationId(conversationId);

    (iframeRef.current as HTMLIFrameElement).contentWindow.__SPOTIM_ENV__ =
      window.__SPOTIM_ENV__ || 'production';
    (iframeRef.current as HTMLIFrameElement).contentWindow.__SPOTIMENV__ =
      window.__SPOTIMENV__ || 'production';

    // This object will be handled as conversation query params.
    let scriptElOptions = document.createElement('script');
    scriptElOptions.type = 'application/json';
    scriptElOptions.setAttribute('id', VIEW_CONVERSATION_ID);
    const placeholderParam = conversationMessageId
      ? `"{{PLACEHOLDER}}": "${conversationMessageId}",`
      : '';
    const redirectParams = isPostsContentType
      ? `,"spot_im_redirect_source": "admin_panel",  "spot_im_content_type": "post", "spot_im_content_id": "${conversationId}"`
      : '';
    scriptElOptions.innerHTML = `{${placeholderParam} "spot_im_highlight_immediate": "true" ${redirectParams}}`;

    if (parentId) {
      scriptElOptions.innerText = scriptElOptions.innerText?.replace(
        '{{PLACEHOLDER}}',
        'spot_im_reply_id'
      );
    } else {
      scriptElOptions.innerText = scriptElOptions.innerText?.replace(
        '{{PLACEHOLDER}}',
        'spot_im_comment_id'
      );
    }

    // Create launcher script and add it to the iframe element
    const launcherScriptElement = document.createElement('script');
    launcherScriptElement.src = `${config.api.launcherOnly}/spot/${spotId}`;
    launcherScriptElement.setAttribute('data-spot-id', spotId);
    launcherScriptElement.setAttribute('data-post-id', postId);
    launcherScriptElement.setAttribute('data-spotim-module', 'spotim-launcher');
    if (isPostsContentType) {
      scriptElOptions.setAttribute('data-auto-run', 'false');
    }

    iframeRef.current.contentDocument.body.appendChild(scriptElOptions);
    iframeRef.current.contentDocument.body.appendChild(launcherScriptElement);
  }, [message]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      requestAnimationFrame(() => {
        appendLauncherScript();
      });
    }
  }, []);

  return (
    <iframe
      style={{ height: '90vh', width: '70vw', backgroundColor: isDarkTheme ? 'black' : 'none' }}
      ref={iframeRef}
    />
  );
};
